import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
    ComponentRef,
    inject,
    Injectable,
    OutputRefSubscription,
} from '@angular/core';
import { ICommunity } from '@interacta/util-community';
import { Observable, of, Subject } from 'rxjs';
import { ILabInteropCommunitySelectionDialogComponent } from '../components/i-lab-interop-community-selection-dialog/i-lab-interop-community-selection-dialog.component';

@Injectable({ providedIn: 'root' })
export class ILabInteropCommunitySelectionDialogStateService {
    private readonly overlay = inject(Overlay);

    private overlayRef: OverlayRef;
    private dialogRef: ComponentRef<ILabInteropCommunitySelectionDialogComponent> | null =
        null;
    private subscriptions: OutputRefSubscription[] = [];

    constructor() {
        this.overlayRef = this.overlay.create();
    }

    open(): Observable<ICommunity | null> {
        if (this.overlayRef.hasAttached()) {
            console.warn(
                'ILabInteropCommunitySelectionDialogComponent is already open',
            );
            return of(null);
        }
        const dialogPortal = new ComponentPortal(
            ILabInteropCommunitySelectionDialogComponent,
        );

        this.dialogRef = this.overlayRef.attach(dialogPortal);

        const result = new Subject<ICommunity | null>();

        this.subscriptions.push(
            this.dialogRef.instance.selectCommunity.subscribe((selection) => {
                result.next(selection);
                result.complete();
                this.close();
            }),
        );

        return result.asObservable();
    }

    close(): void {
        this.dialogRef = null;
        this.subscriptions.forEach((subscription) =>
            subscription.unsubscribe(),
        );
        this.subscriptions = [];
        this.overlayRef.detach();
    }
}
